import React from "react";
import Moment from "moment";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Tooltip from '@material-ui/core/Tooltip';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { green, amber, grey } from '@material-ui/core/colors';

export default class Promotions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      promotions: [],
      products: [],
      loading: false,
      selectedStatus: "",
      selectedProductId: "",
      selectedSyncStatus: "",
    };
  }

    componentDidMount() {
    this.fetchInitialData();
  }

  fetchInitialData = () => {
    this.setState({ loading: true });
    Promise.all([
      this.props.fetchApi("get", "/promotions"),
      this.props.fetchApi("get", "/products"),
    ])
      .then(([promotionsResponse, productsResponse]) => {
        this.setState({
          promotions: promotionsResponse.data.promotions,
          products: productsResponse.data.products,
          loading: false,
        });
      })
      .catch(() => {
        this.props.showSnackbar("Erro ao carregar dados. Tente novamente.");
        this.setState({ loading: false });
      });
  };

  handleFilterChange = (filterName, value) => {
    this.setState({ [filterName]: value });
  }

  // Helper to determine the combined sync status
  getSyncStatus = (promo) => {
    if (promo.status === 0) { // 0 = SCHEDULED
        return 'not_applicable';
    }
    if (promo.googlePlaySyncStatus === 'pending' || promo.appleStoreSyncStatus === 'pending') {
        return 'error';
    }
    // If both are 'synced' (or default), the status is success
    return 'success';
  }

  computeFilteredPromotions = () => {
    const { promotions, selectedStatus, selectedProductId, selectedSyncStatus } = this.state;
    
    return promotions.filter(promo => {
        const statusMatch = selectedStatus === "" || promo.status === Number(selectedStatus);
        const productMatch = selectedProductId === "" || (promo.product && promo.product.id === selectedProductId);
        const syncMatch = selectedSyncStatus === "" || this.getSyncStatus(promo) === selectedSyncStatus;
        
        return statusMatch && productMatch && syncMatch;
    });
  }

  renderSyncStatus = (promo) => {
    const syncStatus = this.getSyncStatus(promo);
    const syncStatusTextMap = {
      success: 'Sucesso',
      error: 'Pendente/Erro',
      not_applicable: 'N/A'
    };
    const text = syncStatusTextMap[syncStatus] || 'N/A';

    let icon;
    switch (syncStatus) {
      case 'success':
        icon = <CheckCircleIcon style={{ color: green[500], marginRight: '8px' }} />;
        break;
      case 'error':
        icon = <WarningIcon style={{ color: amber[500], marginRight: '8px' }} />;
        break;
      case 'not_applicable':
      default:
        icon = <HelpOutlineIcon style={{ color: grey[500], marginRight: '8px' }} />;
        break;
    }

    return (
      <Tooltip title={text === 'Pendente/Erro' ? 'Sincronização pendente ou com erro' : `Sincronização: ${text}`}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {icon}
          <Typography variant="body2">{text}</Typography>
        </div>
      </Tooltip>
    );
  }

  render() {
    const { products, loading, selectedStatus, selectedProductId, selectedSyncStatus } = this.state;
    const filteredPromotions = this.computeFilteredPromotions();
    const promotionStatusMap = {
      0: "AGENDADA",
      1: "ATIVA",
      2: "CONCLUÍDA",
      3: "CANCELADA",
      4: "AGUARDANDO CANCELAMENTO",
    };

    return (
      <div>
        <br />
        <br />
        <Card style={{ padding: "1rem" }}>
          <Typography color="textSecondary" gutterBottom>
            Lista de Promoções Agendadas
          </Typography>
          <br />
          <div style={{ display: "flex", alignItems: 'flex-end', gap: '2rem' }}>
            {/* Status Filter */}
            <div>
              <InputLabel shrink>Filtrar por status</InputLabel>
              <Select value={selectedStatus} onChange={(e) => this.handleFilterChange('selectedStatus', e.target.value)} displayEmpty>
                <MenuItem value="">TODOS</MenuItem>
                <MenuItem value="0">AGENDADA</MenuItem>
                <MenuItem value="1">ATIVA</MenuItem>
                <MenuItem value="2">CONCLUÍDA</MenuItem>
                <MenuItem value="3">CANCELADA</MenuItem>
              </Select>
            </div>

            {/* Product Filter */}
            <div>
              <InputLabel shrink>Filtrar por produto</InputLabel>
              <Select value={selectedProductId} onChange={(e) => this.handleFilterChange('selectedProductId', e.target.value)} displayEmpty>
                <MenuItem value="">TODOS</MenuItem>
                {products.map(product => (
                    <MenuItem key={product.id} value={product.id}>{product.name}</MenuItem>
                ))}
              </Select>
            </div>

            {/* Sync Status Filter */}
            <div>
              <InputLabel shrink>Filtrar por sincronização</InputLabel>
              <Select value={selectedSyncStatus} onChange={(e) => this.handleFilterChange('selectedSyncStatus', e.target.value)} displayEmpty>
                <MenuItem value="">TODOS</MenuItem>
                <MenuItem value="success">Sucesso</MenuItem>
                <MenuItem value="error">Pendente/Erro</MenuItem>
                <MenuItem value="not_applicable">N/A</MenuItem>
              </Select>
            </div>

            <div style={{ marginLeft: 'auto' }}>
                <Button variant="contained" color="primary" onClick={() => this.props.navigateToPromotionCreate()}>
                    Agendar Nova Promoção
                </Button>
            </div>
          </div>
          <br />
          <br />

          {loading ? (
            <CircularProgress style={{ marginLeft: "1rem" }} />
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nome da Promoção</TableCell>
                    <TableCell>Produto</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Quantidade de Compras</TableCell>
                    <TableCell>Desconto Total</TableCell>
                    <TableCell>Valor do Desconto</TableCell>
                    <TableCell>Data de Início</TableCell>
                    <TableCell>Data de Término</TableCell>
                    <TableCell>Sincronização Lojas</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredPromotions.map((promo) => (
                    <TableRow
                      key={promo.id}
                      hover
                      onClick={() => this.props.navigateToPromotion(promo.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <TableCell>{promo.name}</TableCell>
                      <TableCell>{(promo.product && promo.product.name) || (promo.product && promo.product.id) || 'N/A'}</TableCell>
                      <TableCell>{promotionStatusMap[promo.status] || "Desconhecido"}</TableCell>
                      <TableCell>{promo.usageCount || 0}</TableCell>
                      <TableCell>{promo.totalDiscount ? `R$ ${parseFloat(promo.totalDiscount).toFixed(2).replace('.', ',')}` : 'R$ 0,00'}</TableCell>
                      <TableCell>R$ {promo.discountAmount.toFixed(2)}</TableCell>
                      <TableCell>{Moment(promo.startDate).format("DD/MM/YYYY")}</TableCell>
                      <TableCell>{Moment(promo.endDate).format("DD/MM/YYYY")}</TableCell>
                      <TableCell>{this.renderSyncStatus(promo)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Promotions.js